import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Microphone"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.25 10.5V12.75C17.25 15.6495 14.8995 18 12 18C9.10051 18 6.75 15.6495 6.75 12.75V10.5H5.25V12.75C5.25163 16.1865 7.83481 19.0732 11.25 19.455V21H8.25V22.5H15.75V21H12.75V19.455C16.1652 19.0732 18.7484 16.1865 18.75 12.75V10.5H17.25ZM15.75 12.75C15.75 14.8211 14.0711 16.5 12 16.5C9.92893 16.5 8.25 14.8211 8.25 12.75V5.25C8.25 3.17893 9.92893 1.5 12 1.5C14.0711 1.5 15.75 3.17893 15.75 5.25V12.75ZM12 3C10.7574 3 9.75 4.00736 9.75 5.25V12.75C9.75 13.9926 10.7574 15 12 15C13.2426 15 14.25 13.9926 14.25 12.75V5.25C14.25 4.00736 13.2426 3 12 3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Microphone.vue"]]);
